import { DOCS_URL } from '../../../../generic/Link/DocsLink';

export const SSO_DOCS_URL = `${DOCS_URL}/single-sign-on`;
